import { Link } from "react-router-dom";
import "./ProjectCard.css";

function ProjectCard({ project }) {
  return (
    <article className="project-card">

      {/* PROJECT IMAGE */}
      <div className="project-image">

        <img
          src={project.image}
          alt={project.title}
        />

        <span className="project-status">
          {project.status}
        </span>

      </div>


      {/* PROJECT CONTENT */}
      <div className="project-content">

        <div className="project-meta">

          <span>
            {project.type}
          </span>

          <span>
            {project.year}
          </span>

        </div>


        <h3>
          {project.title}
        </h3>


        <p className="project-subtitle">
          {project.subtitle}
        </p>


        <p className="project-location">
          📍 {project.location}
        </p>


        {/* TAGS */}
        <div className="project-tags">

          {project.tags?.map((tag) => (
            <span key={tag}>
              {tag}
            </span>
          ))}

        </div>


        {/* VIEW AAR */}
        <Link
          to={`/aar/${project.id}`}
          className="view-aar"
        >
          View AAR
          <span>→</span>
        </Link>

      </div>

    </article>
  );
}

export default ProjectCard;